// Third-party Imports
import styled from '@emotion/styled'

// Util Imports
import { verticalNavClasses } from '../../utils/menuClasses'

const StyledVerticalNav = styled.aside`
  position: sticky;
  inset-block-start: 0;
  block-size: 100dvh;
  z-index: 9;

  /* Transition */
  transition-property: inline-size, min-inline-size, margin-inline-start, inset-inline-start;
  transition-duration: ${({ transitionDuration }) => `${transitionDuration}ms`};
  transition-timing-function: ease-in-out;

  /* Width & Min Width & Margin */
  inline-size: ${({ width, isCollapsed }) => (isCollapsed ? '68px' : `${width}px`)};
  min-inline-size: ${({ width, isCollapsed }) => (isCollapsed ? '68px' : `${width}px`)};

  /* Collapsed */
  &.${verticalNavClasses.collapsed} {
    box-shadow: var(--mui-customShadows-sm);
    z-index: 1000;
  }

  /* Toggled */
  &.${verticalNavClasses.breakpointReached} {
    position: fixed;
    block-size: 100%;
    inset-block-start: 0;
    inset-inline-start: ${({ width }) => `-${width}px`};
    z-index: 100;
    margin: 0;
    &.${verticalNavClasses.toggled} {
      inset-inline-start: 0;
    }
  }

  ${({ width, isBreakpointReached }) =>
    !isBreakpointReached &&
    `
    &.${verticalNavClasses.toggled} {
      margin-inline-start: -${width}px;
    }
  `}

  /* User Styles */
  ${({ customStyles }) => customStyles}
`

export default StyledVerticalNav
